import { useSettings } from '@wu/widget-core';

export const useIsWaveformProgress = () => {
  const { playbackProgressStyle } = useSettings();

  return playbackProgressStyle === 'waveform';
};
